import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/templates";

export const listAllTemplates = async (query: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.get(url, {
      params: query,
    });
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getTemplateByIdSelectMinimalData = async (id: string) => {
  try {
    let url = `${endpoint}/${id}/minimal-data`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getTemplateById = async (id: string) => {
  try {
    let url = `${endpoint}/${id}`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getTemplateUsageInSetsById = async (id: string) => {
  try {
    let url = `${endpoint}/${id}/usage`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const createTemplate = async (templateData: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.post(url, templateData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updateTemplate = async (templateId: number, templateData: any) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.put(url, templateData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const duplicateTemplateById = async (templateId: any) => {
  try {
    let url = `${endpoint}/${templateId}/duplicate`;
    const result = await adminApi.post(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updateTemplateSettingsOnly = async (
  templateId: number,
  templateData: any
) => {
  try {
    let url = `${endpoint}/${templateId}/settings-only`;
    const result = await adminApi.put(url, templateData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const deleteTemplate = async (templateId: string) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.delete(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
